import Swiper, { Navigation, Pagination } from "swiper";

export default function EventsCarousel() {
    document.querySelectorAll(".events-carousel").forEach((el) => {

        const swiper = new Swiper(el, {
            modules: [Navigation, Pagination],
            loop: true,
            pagination: {
                el: el.querySelector(".swiper-pagination"),
                type: "fraction",
                formatFractionCurrent: addZero,
                formatFractionTotal: addZero
            },
            navigation: {
                nextEl: el.querySelector(".sw-next"),
                prevEl: el.querySelector(".sw-prev"),
            },
        });

        function addZero(num){
            return (num > 9) ? num : '0' + num;
          }
    });
}
